const mintA = {
  mintA1: "hsla(168, 95.4%, 42.8%, 0.024)",
  mintA2: "hsla(164, 99.1%, 47.1%, 0.063)",
  mintA3: "hsla(164, 99.3%, 43.5%, 0.118)",
  mintA4: "hsla(164, 99.3%, 41.3%, 0.177)",
  mintA5: "hsla(165, 99.0%, 37.5%, 0.248)",
  mintA6: "hsla(165, 100%, 35.0%, 0.353)",
  mintA7: "hsla(166, 99.9%, 33.5%, 0.510)",
  mintA8: "hsla(168, 99.6%, 34.6%, 0.750)",
  mintA9: "hsla(167, 99.9%, 39.5%, 0.561)",
  mintA10: "hsla(167, 99.7%, 37.4%, 0.589)",
  mintA11: "hsla(172, 99.8%, 22.4%, 0.922)",
  mintA12: "hsla(172, 99.7%, 8.8%, 0.965)"
};
export { mintA };
//# sourceMappingURL=mintA.mjs.map
